import { Rect } from "../.././MyHelpers";
import { MultigameParams } from "../../MultigameParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";


// export namespace SlotGames { SlotGameType1 } from "../SlotGameType1";
// {

	export class AmazingPanda extends SlotGameType1 
	{

		////protected override freegameBonusFactory: FreegameBonusFactory = new AmazingPandaFreegameBonusFactory();
		
		//protected panelFactory:IPanelFactory = new AmazingPandaPanelFactory();
		//LED COLOR
		protected override ColorLed:string="0,255,0\n";
		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "orange",
        };

		protected override pickBonusFactory:PickBonusFactory = new PandaPickBonusFactory();
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "AmazingPanda");

			
			//this.spinnableReelsParams.topBorderWidth = 10;
			//this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}

	// class AmazingPandaFreegame extends FreegameBonus
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 10;
	// 		this.spinnableReelsParams.bottomBorderWidth = 10;
	// 	}
		

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "90px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.fontSize = "50px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}
	

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void 
	// 	{
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "go3v2.ttf", this.resid.ScopedResourceName(["lines", "font"])));
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 600;
	// 		let displayHeight: number = 600;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(0, 320, displayWidth, displayHeight),
	// 			new PixelRect(331, 320, displayWidth, displayHeight),
	// 			new PixelRect(665, 320, displayWidth, displayHeight),
	// 			new PixelRect(999, 320, displayWidth, displayHeight),
	// 			new PixelRect(1323, 320, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(171, 86, 200, 513);
			
	// 		let awardRect = new PixelRect(0, 0, displayWidth, displayHeight);
			
	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	//CREATE FOR ROTATE ONLY THE PICK ELEMENT
	// 	protected override PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 		let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 		this.canvasSprite = null;
	
	// 		for (let i = 0; i < 5; i++) {
	
	// 			let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 			//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 			this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	
	// 			let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 				i, 
	// 				this.logGroup,
	// 				pickGeometries[i].displayRect, 
	// 				pickGeometries[i].pickRect, 
	// 				pickGeometries[i].awardRect, 
	// 				this.canvasSprite
	// 			);
					
	// 			let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);
	// 			//ROTATE PICK FOR FILL IMG
	// 			pick.pickElem.style.transform="rotate(45deg)";
	// 			pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 			pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 			pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));
	
	// 			pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 			pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));
	
				
	// 			this.picks.push(pick);
	// 			this.picksContainer.appendChild(pick.View());
				
	// 		}
	// 	}
		

	// 	protected override PreparePickIntroMessage(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePickIntroMessage(resourceManager);
	// 		let m: HTMLElement = this.pickIntroMessageContainer.querySelector(".pickMessageContainer");
	// 		m.style.color = "#fec600";
	// 		m.style.fontFamily = resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name;
	// 	}

	// 	protected override PreparePicksContainer(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePicksContainer(resourceManager);
	// 		this.picksContainer.style.color = "#fec600";
	// 		this.picksContainer.style.fontFamily = resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name;
	// 	}

	// 	protected override PreparePickMessageContainer(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePickMessageContainer(resourceManager);
	// 		let m: HTMLElement = this.pickedMessageContainer.querySelector(".messageContainer");
	// 		m.style.color = "#fec600";
	// 		m.style.fontFamily = resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name;
	// 	}

	// 	protected override PrepareFinalMessage(resourceManager: ResourceManager): void
	// 	{
	// 		super.PrepareFinalMessage(resourceManager);
	// 		let m: HTMLElement = this.finalMessageContainer.querySelector(".messageContainer");
	// 		m.style.color = "#fec600";
	// 		m.style.fontFamily = resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name;
	// 	}
		
	// }




	// then you make this class but change the name for evey game
	class PandaPickBonus extends PickBonus
	{
		public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
			throw new Error("Method not implemented.");
		}
	}

	class PandaPickBonusElement extends PickBonusElement
	{
	}
	


	class AmazingPandaFreegamePickElement extends FreegamePickElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "-4px";
			this.awardElem.style.top = "2px";
			this.awardElem.style.fontSize ="150px";
			
		}

		protected override PreparePickedElement(): void
		{
			this.awardElem.style.color = "yellow";
			this.awardElem.style.fontSize = "150px";
			this.awardElem.style.fontWeight="bold";
		}

		protected override PrepareRemainingElement(): void
		{
			this.awardElem.style.removeProperty("color");
			this.awardElem.style.removeProperty("fontSize");
		}
	}

	//Panel Colorized
	class AmazingPandaPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new AmazingPandaPanel(params);
		}
	}

	class AmazingPandaPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(43, 1, 0),rgb(72, 4, 1), rgb(127, 11, 5),rgb(72, 4, 1),rgb(43, 1, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, rgb(217, 179, 67),transparent ) 0 10 100%",
			};
			return color;
			
		}

	}


	// class AmazingPandaFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new AmazingPandaFreegame(gameName, params);
	// 	}
		
		
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new AmazingPandaFreegamePickElement(params);
	// 	}
		
	// }

	class PandaPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new PandaPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new PandaPickBonusElement(params);
		}
		
	}
// }
